import { render, staticRenderFns } from "./FFPageSearch.vue?vue&type=template&id=f035d364&scoped=true&"
import script from "./FFPageSearch.vue?vue&type=script&lang=js&"
export * from "./FFPageSearch.vue?vue&type=script&lang=js&"
import style0 from "./FFPageSearch.vue?vue&type=style&index=0&id=f035d364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f035d364",
  null
  
)

export default component.exports